import { IKpi, IAverageKpisReturn } from '../../../types/kpis';
import { IUser } from '../../../types/users';

export enum ActionTypes {
  getKpisRequest = 'GET_KPIS_REQUEST',
  getKpisSuccess = 'GET_KPIS_SUCCESS',
  getKpisFailure = 'GET_KPIS_FAILURE',
}

export interface IKpisState {
  kpis: IKpi[];
  averages: IAverageKpisReturn[];
  labels: string[];
}

export interface IKpisInput {
  user: IUser;
  jwt: string;
  startDate?: Date | null;
  endDate?: Date | null;
  timescale: string;
}

export interface IGetkpisRequestReturn {
  type: string;
  payload: {
    input: IKpisInput;
  };
}

export interface IKpisSuccessInput {
  kpis: IKpi[];
  averages: IAverageKpisReturn[];
  labels: string[];
}

export interface IGetKpisSuccessReturn {
  type: string;
  payload: {
    input: IKpisSuccessInput;
  };
}

export interface IkpisResponse {
  status: string;
  kpi: IKpi[];
}
